module.exports = __webpack_public_path__ + "static/media/Avenir-Black.4e68f50f.woff2";